import PageHeader from '../components/ui/PageHeader';
import { EmptyState } from '../components/ui/States';

/** Temporary page for screens that haven't been built yet. */
export default function PlaceholderPage({ title }) {
  return (
    <>
      <PageHeader title={title} />
      <section className="bg-surface-container-lowest rounded-xl border border-outline-variant/30 shadow-xs">
        <EmptyState icon="construction" title="Coming soon" description={`The ${title} screen is under construction.`} />
      </section>
    </>
  );
}
